import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, Input } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup, FormBuilder,
  Validators,
} from '@angular/forms';
import { LoadingController, ModalController } from '@ionic/angular';
import { CreateApplication } from '../../core/model/application.model';
import { ApplicationService } from '../../services/application/application.service';
import { DropdownService } from '../../services/dropdown/dropdown.service';
import { Errors, validationType } from '../../core/model/error.model';
import { CommonService } from '../../services/common/common.service';
import { UserService } from '../../services/user/user.service';
import { User } from '../../core/model/user.model';
import { OopsModalComponent } from '../oops-modal/oops-modal.component';
import { nonkycModelComponent } from '../non-kyc-modal/non-kyc-model.component'
import { InvestorType, PanType } from 'src/app/core/constants/enum';
import { Router } from '@angular/router';
import { Holder } from 'src/app/core/model/holder.model';
import { HolderService } from 'src/app/services/holder/holder.service';
import { ToastController } from '@ionic/angular';
import {
  NUVAMA_PAN
} from '../../core/constants/app-strings';
// import { parse } from 'path';
import { formatDate } from '@angular/common';
import { OTPValidationModal } from '../otpValidationModel/otp-validation-modal.component';
import { dailogModal } from '../dailog-Modal/dailog-modal';
import { CkycOkayModel } from '../okay-modal/okay-modal';

@Component({
  selector: 'pan-check',
  templateUrl: './pan-check.component.html',
  styleUrls: ['./pan-check.component.scss'],
})
export class PanCheckComponent implements OnInit {
  @Input() isTransferee: boolean = false;
  @Output() success: EventEmitter<any> = new EventEmitter();
  applicantForm: FormGroup;
  floatLabelControl = new FormControl('always');
  status: boolean = false;
  error = Errors;
  showLoader = false;
  headerText = ''; //HEADER_TEXT_PANCHECK;
  messageText = ''; //MESSAGE_TEXT_PANCHECK;
  parentFund: any;
  holder: any;
  distributorPanDetails: any;
  childFund: any;
  showSubmitButton: boolean = true;
  RmName: [{ name: 'Jinal' }];
  CKYCMobileNo: any;
  distributorDetails: any;
  ckycSearchData: string = ""
  todayDate = new Date();
  NonCkycPopup: boolean = false;
  investorType = InvestorType;
  panType = PanType;
  transferIDs: any;
  transferData: any;
  nuvamaPan = NUVAMA_PAN.toString()
  panFixed: boolean = false;
  dobFixed: boolean = false;
  checkPan: boolean = false;
  requestId: any;
  usingOTPFlow: boolean = false;
  distributorEntityName: any;
  userEmail: any;
  ckycFlag: boolean = false;
  KRAFlag: boolean = false;
  constructor(
    // private readonly userService: UserService,
    private modalController: ModalController,
    private readonly commonService: CommonService,
    private readonly dropdownService: DropdownService,
    private readonly applicationService: ApplicationService,
    private readonly loadingController: LoadingController,
    private holderService: HolderService,
    private userService: UserService,
    private toastController: ToastController,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.createForm();
    this.getUserData();
    this.getDropDownValues();
    this.investorTypeListerner();
    this.getChildFund();
    // this.getTransferId();
    this.getDistributorPanDetailsForTransfer();
  }

  get form() {
    return this.applicantForm.controls;
  }

  investorTypeListerner() {
    this.form.typeOfInvestor.valueChanges.subscribe((data) => {
      if (this.form.typeOfInvestor.value === this.investorType.NonIndividual) {
        this.form.legalStatus.setValue('RI');
        this.form.legalStatus.updateValueAndValidity();
        this.removeAddValidation();
      } else {
        this.form.typeOfEntity.setValue('');
        this.form.typeOfEntity.updateValueAndValidity();
        this.removeAddValidation();
      }
    });
  }
  //Comments for CICD
  // get InvestorType() {
  //   if (localStorage.getItem('InvestorType') === 'Non-Individual') {
  //     this.form.typeOfEntity.setValidators(validationType.Required);
  //     this.form.legalStatus.setValidators(null);
  //     return this.investorType.Non_Individual;
  //   } else {
  //     return this.investorType.Individual;
  //   }
  // }

  getUserData() {
    this.userService.getUser().subscribe((res: User) => {
      this.distributorEntityName = res.distributorEntityName;
      this.userEmail = res.email;
      this.distributorDetails = JSON.parse(res.distributorDetails);
    });
  }
  onTransferIdSelect(data) {
    console.log(data.transferId)
    const categoryOfUser = this.applicantForm.get('categoryOfUser').value;
    if (categoryOfUser !== 'Transferee' && !data.transferId) {
      return
    }
    this.dropdownService.getTransferDetails(data.transferId).subscribe((response) => {
      this.transferData = response.data;
      console.log("this.transferData", this.transferData);

      this.applicantForm.get('pan').setValue(this.transferData.buyerPan || '');
      this.applicantForm.get('dob').setValue(this.transferData.buyerDOB ? new Date(this.transferData.buyerDOB) : '');
      this.applicantForm.get('aifName').setValue(this.transferData.fundId);
      this.applicantForm.get('typeOfInvestor').setValue(this.transferData.typeOfInvestor);
      console.log('this.applicantForm.get("aifName")', this.applicantForm.get('aifName'));
      this.onChangePan('');
    });
  }

  onTypeOfInvestorChange() {
    this.applicantForm.get('pan').setValue('');
    this.applicantForm.get('dob').setValue('');
    this.applicantForm.get('aifName').setValue('');
    this.applicantForm.get('status').setValue('');
    this.applicantForm.get('dateOfIncorporation').setValue('');
    this.form.applicationStatus.setValue('')
    console.log(this.form);
  }

  onChangePan(e) {
    let pan = this.form.pan.value;
    const categoryOfUser = this.applicantForm.get('categoryOfUser').value;
    if (categoryOfUser == "Transferee") {
      this.prefillData();
    }

    if (this.form.typeOfInvestor.value === this.investorType.Individual) return;

    if (pan.charAt(3).toUpperCase() === 'C') {
      this.form.applicationStatus.setValue(this.panType.Company);
    } else if (pan.charAt(3).toUpperCase() === 'H') {
      this.form.applicationStatus.setValue(this.panType.HUF);
    } else if (pan.charAt(3).toUpperCase() === 'A') {
      this.form.applicationStatus.setValue(this.panType.AOP);
    } else if (pan.charAt(3).toUpperCase() === 'B') {
      this.form.applicationStatus.setValue(this.panType.BOI);
    } else if (pan.charAt(3).toUpperCase() === 'G') {
      this.form.applicationStatus.setValue(this.panType.GovernmentAgency);
    } else if (pan.charAt(3).toUpperCase() === 'J') {
      this.form.applicationStatus.setValue(this.panType.ArtificialJuridicalPerson);
    } else if (pan.charAt(3).toUpperCase() === 'L') {
      this.form.applicationStatus.setValue(this.panType.LocalAuthority);
    } else if (pan.charAt(3).toUpperCase() === 'F') {
      this.form.applicationStatus.setValue(this.panType.FirmLiabilityPartnership);
    } else if (pan.charAt(3).toUpperCase() === 'T') {
      this.form.applicationStatus.setValue(this.panType.Trust);
    }
    else {
      this.form.applicationStatus.setValue('');
      this.form.pan.setErrors({ notvalid: true });
    }
    // this.applicantForm.get('status')?.setValue('Private Limited');
  }

  selectStatus() {
    // this.form.applicationStatus.setValue(this.form.status.value);
    // this.form.applicationStatus.updateValueAndValidity();
  }

  prefillData() {
    let nuwama = this.distributorPanDetails.filter(x => x.pan == this.form.pan.value);
    if (nuwama.length > 0) {
      this.form.applicationStatus.setValue('Company');
      this.form.typeOfEntity.setValue(nuwama[0].typeOfEntity);
      this.form.status.setValue(nuwama[0].investorStatus);
      const input = nuwama[0].dob;
      const [day, month, year] = input.split('-').map(Number);
      const parsedDate = new Date(year, month - 1, day);

      if (this.form.typeOfInvestor.value === this.investorType.Individual) {
        this.applicantForm.get('dob')?.setValue(parsedDate);
      } else {
        this.applicantForm.get('dateOfIncorporation')?.setValue(parsedDate);
      }



    }

  }

  createForm() {
    const pan = /^[a-zA-Z]{5}\d{4}[a-zA-Z]{1}$/;
    const CKYCMobileNo = /^[6-9]\d{9}$/;
    this.applicantForm = new FormGroup({
      pan: new FormControl('', [Validators.required, Validators.pattern(pan)]),
      dob: new FormControl('', [Validators.required]),
      // fundName: new FormControl('', [Validators.required]),
      aifName: new FormControl('', [Validators.required]),
      legalStatus: new FormControl('RI', Validators.required),
      CKYCMobileNo: new FormControl('', [Validators.pattern(CKYCMobileNo)]),
      rmName: new FormControl('', Validators.required),
      typeOfEntity: new FormControl('Financial Institution'),
      typeOfInvestor: new FormControl('Individual'),
      applicationStatus: new FormControl(''),
      dateOfIncorporation: new FormControl(''),
      status: new FormControl(''),
      POA: new FormControl(false),
      transferId: new FormControl(''),
      categoryOfUser: this.isTransferee ? new FormControl('Transferee') : new FormControl('Fresh')
    });
  }

  toggleToolTip() {
    this.status = !this.status;
  }

  getDropDownValues() {


    // let userInfo = this.userService.cookieDataFromOtherDomain()

    // console.log("userInfo==> ", userInfo)
    // this.parentFund = userInfo.userData.objUserFundsList

    this.dropdownService.getParentFund().subscribe(
      (res: any) => {
        this.parentFund = res;
      },
      (err) => {
        console.log(err)
      }
    );
  }

  getChildFund() {
    let childFlag = "F";
    if (this.isTransferee) {
      childFlag = "TR";
    }

    this.dropdownService
      .getChildFund(childFlag)
      // .getChildFund(this.form.fundName.value.fundID)
      .subscribe(
        (res: any) => {

          this.childFund = res;

          if (!this.isTransferee && (this.distributorEntityName.includes('Nuvama') || this.distributorEntityName === 'Spark PWM Private Limited')) {
            this.childFund = res.filter(x => x.fundId !== 'FUND369');
          }

          if (this.distributorEntityName.includes('Nuvama Wealth and Investment Limited') === false) {
            this.childFund = this.childFund.filter(x => x.fundId !== 'FUND400');
            this.childFund = this.childFund.filter(x => x.fundId !== 'FUND401');
          }
        },
        (err) => { }
      );
  }

  getTransferId() {
    this.dropdownService.getTransferId().subscribe(
      (res: any) => {
        this.transferIDs = res.data.transferDetails;
        console.log("this.transferId", this.transferIDs);
        this.transferIDs = this.transferIDs.filter(x => x.status == 'Approved' && x.buyerUserId == this.distributorDetails[0].UserId);
        console.log("this.transferId", this.transferIDs);
      },
      (err) => {
        console.log("Error =>", err)
      }
    );
  }

  getDistributorPanDetailsForTransfer() {//khans
    this.dropdownService.getDistributorPanDetailsForTransfer().subscribe(
      (res: any) => {
        console.log("res.data", res.data);
        this.distributorPanDetails = res.data;
      },
      (err) => {
        console.log("Error =>", err)
      }
    );
  }

  // get TypeOfInvestor() {
  //   if (
  //     this.form &&
  //     this.form.typeOfInvestor.value === this.investorType.Individual
  //   ) {
  //     return this.investorType.Individual;
  //   } else {
  //     this.removeAddValidation();
  //     return this.investorType.NonIndividual;
  //   }
  // }

  removeAddValidation() {
    if (this.form.typeOfInvestor.value === this.investorType.NonIndividual) {
      this.form.dob.setValidators(null);
      this.form.dob.updateValueAndValidity();
      this.form.dateOfIncorporation.setValidators(validationType.Required);
      this.form.dateOfIncorporation.updateValueAndValidity();
    } else {
      this.form.dob.setValidators(validationType.Required);
      this.form.dob.updateValueAndValidity();
      this.form.dateOfIncorporation.setValidators(null);
      this.form.dateOfIncorporation.updateValueAndValidity();
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  charAt(abstractControl: AbstractControl) {
    if (!abstractControl.value) return;

    if (abstractControl.value.charAt(3) !== 'P') {
      return { inProper: true };
    } else return null;
  }

  isAlphaNumericKey(event) {
    if (this.commonService.isAlphaNumericKey(event)) {
      if (this.applicantForm.value.pan.length === 10) {
        return false;
      } else return true;
    } else {
      return false;
    }
  }

  changePOA(event) {
    if (event.checked) {
      this.form.POA.setValue(true);
    }
    else {
      this.form.POA.setValue(false);
    }
  }

  async onSubmitCKYC() {
    this.applicantForm.markAllAsTouched();
    if (this.applicantForm.invalid) return;
    if (
      this.form.typeOfInvestor.value === this.investorType.Individual &&
      this.form.pan.value.charAt(3).toUpperCase() !== 'P'
    ) {
      this.form.pan.setErrors({ inProper: true });
      return;
    }
    this.showLoader = true;
    const PAN = this.form.pan.value
    const DOB = ""

    const CKYCpayload = {
      PAN: PAN,
      DOB: DOB
    }

    this.applicationService.CKYCSearchAPI(CKYCpayload).subscribe({
      next: (CkysRes: any) => {
        const CkycData = CkysRes?.data ?? null;
        if (CkycData !== null) {
          this.ckycSearchData = CkycData;
          this.ckycFlag = true;
        } else {
          this.ckycSearchData = null
          this.ckycFlag = false;
        }
        //if (CkycData !== null) {
        //Check KRA Search API
        let formatedDate = formatDate(this.form.dob.value, 'dd-MM-yyyy', 'en');
        const KRApayload = {
          PAN: CKYCpayload.PAN,
          DOB: formatedDate
        }
        this.applicationService.KRASearchAPI(KRApayload).subscribe({
          next: async (KRARes: any) => {
            console.log('KRARes', KRARes);
            if (KRARes.message.includes("PAN is not active or not found in KRA")) {
              console.log('PAN Not found');
              this.KRAFlag = false;
              if (this.ckycSearchData == null) {
                let payload = {} as CreateApplication;
                payload.pan = this.form.pan.value;

                if (this.form.typeOfInvestor.value === "Non-Individual") {
                  payload.dateOfIncorporation = this.form.dateOfIncorporation.value;
                  let newDate = new Date(payload.dateOfIncorporation);
                  newDate.setDate(newDate.getDate())
                  let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                  payload.dateOfIncorporation = formatedDate;
                }
                else {
                  payload.dateOfBirth = this.form.dob.value;
                  let newDate = new Date(payload.dateOfBirth);
                  newDate.setDate(newDate.getDate())
                  let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                  payload.dateOfBirth = formatedDate;
                }

                this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
                console.log('this.childFund', this.childFund);
                payload.fundName = this.childFund[0].parentFunName;
                payload.fundID = this.childFund[0].parentFundId;
                payload.aifName = this.childFund[0].fundName;
                payload.childfundID = this.childFund[0].fundId;

                payload.rmName = this.form.rmName.value;
                payload.legalStatus = this.form.legalStatus.value;
                payload.typeOfEntity = this.form.typeOfEntity.value;
                payload.typeOfInvestor = this.form.typeOfInvestor.value;
                payload.POA = this.form.POA.value;
                payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;

                if (this.transferIDs) {
                  this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


                  if (this.transferIDs.length > 0) {
                    payload.transferId = this.form.transferId.value.id;
                    payload.classs = this.transferIDs[0].classs;
                    payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
                    payload.initialContribution = this.transferIDs[0].initialContribution;
                    payload.managementFees = this.transferIDs[0].managementFees;
                    payload.setupFees = this.transferIDs[0].setupFees;
                    payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

                  }
                }

                payload.isTransfer = this.isTransferee;
                payload.transferId = 0;

                payload.ckycStatus = "error";
                payload.ckycDetail = JSON.stringify(null);
                if (CkycData !== null) {
                  payload.ckycNumber = CkycData;
                }

                this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
                  async (res: any) => {
                    this.showLoader = false;

                    let response = JSON.parse(res.data);

                    this.dismissModal();
                    const modal = await this.modalController.create({
                      component: nonkycModelComponent,
                      backdropDismiss: false,
                      cssClass: 'my-custom-class',
                      componentProps: {
                        holder: response,
                        onPanCheck: true
                      }
                    });
                    await modal.present();
                    modal.onDidDismiss().then((event) => { });
                    return;
                  });
              }
              else {
                this.showLoader = false;
                const modal = await this.modalController.create({
                  component: CkycOkayModel,
                  backdropDismiss: false,
                  cssClass: 'my-custom-class',
                  componentProps: {
                    onReturn: async () => {
                      this.dismissModal();
                      this.showSubmitButton = false;
                      this.panFixed = true;
                      this.dobFixed = true
                    }
                  }
                });
                await modal.present();
              }
            }
            else {
              this.applicationService.KRADownloadAPI(KRApayload).subscribe({
                next: async (KRADownloadRes: any) => {
                  console.log('KRADownloadRes', KRADownloadRes);
                  if (KRADownloadRes.message.includes("PAN is not active or not found in KRA")) {
                    console.log('PAN Not found');
                    this.KRAFlag = false;
                    this.showLoader = false;
                    const modal = await this.modalController.create({
                      component: CkycOkayModel,
                      backdropDismiss: false,
                      cssClass: 'my-custom-class',
                      componentProps: {
                        ckycFlag: this.ckycFlag,
                        KRAFlag: this.KRAFlag,
                        onReturn: async () => {
                          this.dismissModal();
                          this.showSubmitButton = false;
                          this.panFixed = true;
                          this.dobFixed = true
                        }
                      }
                    });
                    await modal.present();
                  }
                  else {
                    this.KRAFlag = true;
                    this.showLoader = false;
                    const modal = await this.modalController.create({
                      component: CkycOkayModel,
                      backdropDismiss: false,
                      cssClass: 'my-custom-class',
                      componentProps: {
                        ckycFlag: this.ckycFlag,
                        KRAFlag: this.KRAFlag,
                        onReturn: async () => {
                          this.dismissModal();


                          this.applicantForm.get('CKYCMobileNo').setErrors(null)

                          this.applicantForm.markAllAsTouched();
                          if (this.applicantForm.invalid) return;

                          let payload = {} as CreateApplication;
                          payload.pan = this.form.pan.value;
                          payload.dateOfBirth = this.form.dob.value;
                          let newDate = new Date(payload.dateOfBirth);
                          newDate.setDate(newDate.getDate())
                          let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                          payload.dateOfBirth = formatedDate;

                          this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
                          console.log('this.childFund', this.childFund);
                          payload.fundName = this.childFund[0].parentFunName;
                          payload.fundID = this.childFund[0].parentFundId;
                          payload.aifName = this.childFund[0].fundName;
                          payload.childfundID = this.childFund[0].fundId;

                          payload.rmName = this.form.rmName.value;
                          payload.legalStatus = this.form.legalStatus.value;
                          payload.typeOfEntity = this.form.typeOfEntity.value;
                          payload.typeOfInvestor = this.form.typeOfInvestor.value;
                          payload.POA = this.form.POA.value;
                          payload.mobileNo = this.form.CKYCMobileNo.value
                          payload.ckycStatus = "success";
                          if (this.ckycSearchData !== null) {
                            payload.ckycNumber = this.ckycSearchData
                          } else {
                            payload.ckycNumber = ""
                          }
                          payload.ckycDetail = "";
                          payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;

                          if (this.transferIDs) {
                            this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


                            if (this.transferIDs.length > 0) {
                              payload.transferId = this.form.transferId.value.id;
                              payload.classs = this.transferIDs[0].classs;
                              payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
                              payload.initialContribution = this.transferIDs[0].initialContribution;
                              payload.managementFees = this.transferIDs[0].managementFees;
                              payload.setupFees = this.transferIDs[0].setupFees;
                              payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

                            }
                          }

                          payload.isTransfer = this.isTransferee;
                          payload.transferId = 0;
                          payload.KRA = JSON.stringify(KRADownloadRes);

                          this.showLoader = true;
                          this.headerText = '';
                          this.messageText = '';
                          this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
                            async (res: any) => {
                              let data = JSON.parse(res.data)
                              this.showLoader = false;
                              this.commonService.encrypt(data.investorId).subscribe((res: any) => {
                                let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                                this.commonService.encrypt(data.investmentId).subscribe((res: any) => {
                                  let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                                  window.location.href = '/application/applicant-kyc-details/' + investorId + "/" + investmentId;

                                });

                              });
                            },
                            async (error) => {
                              this.showLoader = false;
                              this.dismissModal();
                              const toast = await this.toastController.create({
                                message: 'Something went wrong',
                                duration: 2000
                              });
                              toast.present();
                            }
                          );


                        }
                      }
                    });
                    await modal.present();

                  }
                }
              });
            }
          }
        });
        // }
        // else {

        // }
      },
      error: (err) => {
        console.error('CKYC search Api error', err)
      }
    });
  }

  otpVerified(res: any) {

    this.holder = res;
    // let holderData = JSON.parse(this.holder.data)
    let holderData: any;
    if (this.holder.data === undefined)
      holderData = this.holder
    else
      holderData = JSON.parse(this.holder.data)

    let body = {} as Holder;
    body.otpTriggered = true;
    body.uuid = holderData.investorId;

    this.holderService.updateHolderOTP(body).subscribe(
      (res) => {
        setTimeout(() => {
          this.modalController.dismiss();

          this.commonService.encrypt(holderData.investorId).subscribe((res: any) => {

            let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

            this.commonService.encrypt(holderData.investmentId).subscribe((res: any) => {

              let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

              window.location.href = '/application/applicant-kyc-details/' + investorId + "/" + investmentId;

            });

          });



          // this.router.navigateByUrl(
          //   '/application/applicant-kyc-details/' + holderData.investorId + "/" + holderData.investmentId
          // );
        }, 3000);
      },
      (err) => { }
    );
    // this.show = 'success';
    // this.showDiv = 'kycComp';
    // this.dismissmodal()
  }

  continueWithOTP() {
    const mobileControl = this.applicantForm.get('CKYCMobileNo').value;

    if (mobileControl == "") {
      this.applicantForm.get('CKYCMobileNo').setErrors({ otpRequired: true });
      this.applicantForm.markAllAsTouched();
      return
    }

    if (this.form.CKYCMobileNo.status == 'INVALID') {
      mobileControl?.markAsTouched();
      return;
    }

    this.usingOTPFlow = true;

    this.applicantForm.markAllAsTouched();
    if (this.applicantForm.invalid) return;
    if (
      this.form.typeOfInvestor.value === this.investorType.Individual &&
      this.form.pan.value.charAt(3).toUpperCase() !== 'P'
    ) {
      this.form.pan.setErrors({ inProper: true });
      return;
    }

    let payload = {} as CreateApplication;
    payload.pan = this.form.pan.value;

    payload.dateOfBirth = this.form.dob.value;
    let newDate = new Date(payload.dateOfBirth);
    newDate.setDate(newDate.getDate())
    let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
    payload.dateOfBirth = formatedDate;
    this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
    console.log('this.childFund', this.childFund);
    payload.fundName = this.childFund[0].parentFunName;
    payload.fundID = this.childFund[0].parentFundId;
    payload.aifName = this.childFund[0].fundName;
    payload.childfundID = this.childFund[0].fundId;

    payload.rmName = this.form.rmName.value;
    payload.legalStatus = this.form.legalStatus.value;
    payload.typeOfEntity = this.form.typeOfEntity.value;
    payload.typeOfInvestor = this.form.typeOfInvestor.value;
    payload.POA = this.form.POA.value;
    payload.mobileNo = this.form.CKYCMobileNo.value

    console.log('this.transferIDs filteres when submit ', this.transferIDs);
    if (this.transferIDs) {
      this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


      if (this.transferIDs.length > 0) {
        payload.transferId = this.form.transferId.value.id;
        payload.classs = this.transferIDs[0].classs;
        payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
        payload.initialContribution = this.transferIDs[0].initialContribution;
        payload.managementFees = this.transferIDs[0].managementFees;
        payload.setupFees = this.transferIDs[0].setupFees;
        payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

      }
    }

    payload.isTransfer = this.isTransferee;
    payload.transferId = 0;

    payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;
    this.showLoader = true;
    this.headerText = 'Check CKYC';
    this.messageText = 'Please wait, Verifying CKYC and AML';

    this.requestId = this.commonService.generateRequestId();
    let reqBody;

    reqBody = {
      PAN: payload.pan,
      DOB: formatedDate,
      mobile: payload.mobileNo,
      requestId: this.requestId
    }

    this.applicationService.getCKYC(reqBody).subscribe(
      async (res: any) => {
        let datares = res.value.data;
        if (res.message.includes('OTP has been sent to the registered mobile number')) {
          payload.ckycDetail = JSON.stringify(datares);
          this.dismissModal()
          const modal = await this.modalController.create({
            component: OTPValidationModal,
            backdropDismiss: false,
            cssClass: 'myCustomClass',
            componentProps: {
              mobileNumber: this.form.CKYCMobileNo.value,
              pan: payload.pan,
              dob: formatedDate,
              requestId: this.requestId,
              onVerified: async (res: any) => {
                this.showLoader = true;
                payload.ckycStatus = "SUCCESS";
                payload.ckycDetail = JSON.stringify(res.value.data)
                this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
                  async (res: any) => {
                    this.showLoader = false;
                    this.otpVerified(res);
                  },
                  async (err) => {
                    this.showLoader = false;
                    this.dismissModal();

                    const toast = await this.toastController.create({
                      message: "Something went wrong",
                      duration: 2000,
                    });
                    toast.present();
                  }
                )
              }
            }
          });
          await modal.present();
        } else if (res.value.status === 'ERROR') {
          this.showLoader = false
          const errorMsg: string = res.message || '';
          if (errorMsg.toLowerCase().includes('date of birth')) {
            this.applicantForm.get('dob').setErrors({ dobNotMatched: true })
            this.applicantForm.markAllAsTouched();
          }
          if (errorMsg.toLowerCase().includes('mobile')) {
            this.applicantForm.get('CKYCMobileNo').setErrors({ mobileNotMatched: true })
            this.applicantForm.markAllAsTouched();
            this.cdr.detectChanges();
          }
          if (errorMsg.toLowerCase().includes('no record found')) {
            this.applicantForm.get('pan').setErrors({ noRecordFound: true })
            this.applicantForm.markAllAsTouched();
          }
          if (errorMsg.toLowerCase().includes('please try again')) {
            this.applicantForm.get('pan').setErrors({ serverError: true })
            this.applicantForm.markAllAsTouched();
          }
          return;
        }
      }
    )
  }

  continueWithoutOTP() {

    this.applicantForm.get('CKYCMobileNo').setErrors(null)

    this.applicantForm.markAllAsTouched();
    if (this.applicantForm.invalid) return;

    let payload = {} as CreateApplication;
    payload.pan = this.form.pan.value;
    payload.dateOfBirth = this.form.dob.value;
    let newDate = new Date(payload.dateOfBirth);
    newDate.setDate(newDate.getDate())
    let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
    payload.dateOfBirth = formatedDate;

    this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
    console.log('this.childFund', this.childFund);
    payload.fundName = this.childFund[0].parentFunName;
    payload.fundID = this.childFund[0].parentFundId;
    payload.aifName = this.childFund[0].fundName;
    payload.childfundID = this.childFund[0].fundId;

    payload.rmName = this.form.rmName.value;
    payload.legalStatus = this.form.legalStatus.value;
    payload.typeOfEntity = this.form.typeOfEntity.value;
    payload.typeOfInvestor = this.form.typeOfInvestor.value;
    payload.POA = this.form.POA.value;
    payload.mobileNo = this.form.CKYCMobileNo.value
    payload.ckycStatus = "error";
    if (this.ckycSearchData !== null) {
      payload.ckycNumber = this.ckycSearchData
    } else {
      payload.ckycNumber = ""
    }
    payload.ckycDetail = "";
    payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;

    if (this.transferIDs) {
      this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


      if (this.transferIDs.length > 0) {
        payload.transferId = this.form.transferId.value.id;
        payload.classs = this.transferIDs[0].classs;
        payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
        payload.initialContribution = this.transferIDs[0].initialContribution;
        payload.managementFees = this.transferIDs[0].managementFees;
        payload.setupFees = this.transferIDs[0].setupFees;
        payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

      }
    }

    payload.isTransfer = this.isTransferee;
    payload.transferId = 0;

    this.showLoader = true;
    this.headerText = '';
    this.messageText = '';
    this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
      async (res: any) => {
        let data = JSON.parse(res.data)
        this.showLoader = false;
        this.commonService.encrypt(data.investorId).subscribe((res: any) => {
          let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
          this.commonService.encrypt(data.investmentId).subscribe((res: any) => {
            let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
            window.location.href = '/application/applicant-kyc-details/' + investorId + "/" + investmentId;

          });

        });
      },
      async (error) => {
        this.showLoader = false;
        this.dismissModal();
        const toast = await this.toastController.create({
          message: 'Something went wrong',
          duration: 2000
        });
        toast.present();
      }
    );

  }


  async checkCKYCAddApplicant() {
    this.applicantForm.markAllAsTouched();
    if (this.applicantForm.invalid) return;
    if (
      this.form.typeOfInvestor.value === this.investorType.Individual &&
      this.form.pan.value.charAt(3).toUpperCase() !== 'P'
    ) {
      this.form.pan.setErrors({ inProper: true });
      return;
    }
    let isNUWAMAPan = false;
    // this.charAt()

    let payload = {} as CreateApplication;
    payload.pan = this.form.pan.value;

    const categoryOfUser = this.applicantForm.get('categoryOfUser').value;

    if (this.form.typeOfInvestor.value === "Non-Individual") {
      payload.dateOfIncorporation = this.form.dateOfIncorporation.value;
      let newDate = new Date(payload.dateOfIncorporation);
      newDate.setDate(newDate.getDate())
      let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
      payload.dateOfIncorporation = formatedDate;
    }
    else {
      payload.dateOfBirth = this.form.dob.value;
      let newDate = new Date(payload.dateOfBirth);
      newDate.setDate(newDate.getDate())
      let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
      payload.dateOfBirth = formatedDate;
    }
    console.log('this.form.aifName', this.form.aifName);
    // payload.fundName = this.form.fundName.value.fundName;
    // payload.fundID = this.form.fundName.value.fundID;
    this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
    console.log('this.childFund', this.childFund);
    payload.fundName = this.childFund[0].parentFunName;
    payload.fundID = this.childFund[0].parentFundId;
    payload.aifName = this.childFund[0].fundName;
    payload.childfundID = this.childFund[0].fundId;

    payload.rmName = this.form.rmName.value;
    payload.legalStatus = this.form.legalStatus.value;
    payload.typeOfEntity = this.form.typeOfEntity.value;
    payload.typeOfInvestor = this.form.typeOfInvestor.value;
    payload.POA = this.form.POA.value;

    console.log('this.transferIDs filteres when submit ', this.transferIDs);
    if (this.transferIDs) {
      this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


      if (this.transferIDs.length > 0) {
        payload.transferId = this.form.transferId.value.id;
        payload.classs = this.transferIDs[0].classs;
        payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
        payload.initialContribution = this.transferIDs[0].initialContribution;
        payload.managementFees = this.transferIDs[0].managementFees;
        payload.setupFees = this.transferIDs[0].setupFees;
        payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

      }

    }

    payload.isTransfer = this.isTransferee;
    payload.transferId = 0;

    payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;
    payload.investorStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;
    // this.showLoader = true;
    // this.headerText = 'Check CKYC';
    // this.messageText = 'Please wait, Verifying CKYC and AML';

    let reqBody;
    console.log("payload", payload);
    //return;
    if (this.form.typeOfInvestor.value === "Non-Individual") {
      payload.dateOfIncorporation = this.form.dateOfIncorporation.value;
      let newDate = new Date(payload.dateOfIncorporation);
      newDate.setDate(newDate.getDate())
      let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
      payload.dateOfIncorporation = formatedDate;

      reqBody = {
        PAN: payload.pan,
        DOB: formatedDate
      }
    }
    else {
      payload.dateOfBirth = this.form.dob.value;
      let newDate = new Date(payload.dateOfBirth);
      newDate.setDate(newDate.getDate())
      let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
      payload.dateOfBirth = formatedDate;

      reqBody = {
        PAN: payload.pan,
        DOB: formatedDate
      }
    }
    console.log('this.distributorPanDetails', this.distributorPanDetails);
    let nuwama;
    if (this.distributorPanDetails != undefined) {
      nuwama = this.distributorPanDetails.filter(x => x.pan == this.form.pan.value && x.childfundId == this.childFund[0].fundId);
      if (nuwama.length > 0 && categoryOfUser == "Transferee") {
        isNUWAMAPan = true;
        if (reqBody.DOB != nuwama[0].dob) {

          if (this.form.typeOfInvestor.value === "Non-Individual") {
            this.form.dateOfIncorporation.setErrors({ notvalid: true });
          }
          else {
            this.form.dob.setErrors({ notvalid: true });
          }

          return;
        }
        else {

        }
      }
    }



    this.showLoader = true;
    this.headerText = 'Check CKYC';
    this.messageText = 'Please wait, Verifying CKYC and AML';


    if (categoryOfUser == "Transferee" && isNUWAMAPan) {
      //return;
      payload.ckycStatus = "error";
      payload.ckycDetail = JSON.stringify(null);
      this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
        async (res: any) => {
          this.showLoader = false;
          this.dismissModal();
          let response = JSON.parse(res.data);

          console.log("Pan Check Response ", response)

          this.commonService.encrypt(response.investmentId).subscribe((res: any) => {
            let encryptedText = res.encryptedText;

            console.log('Before encryptedText', encryptedText);

            this.router.navigateByUrl('application/personal-details/' + encryptedText.replaceAll('/', 'slh').replaceAll('--', '==').replaceAll('-', '='));

          });
        },
        async (err) => {
          this.showLoader = false;
          this.dismissModal();
          // const modal = await this.modalController.create({
          const toast = await this.toastController.create({
            message: err.error.message,
            duration: 2000,
          });
          toast.present();
        }
      );
    }
    else {
      if (this.form.typeOfInvestor.value === 'Individual') {
        this.applicationService.getCKYC(reqBody).subscribe(
          async (res: any) => {

            //console.log("res.value.status",res.value.status);
            //console.log("res.value",res.value);
            //payload.ckycStatus = res.value.status;
            let datares = res.value.data;
            if (res.error == 1) {
              payload.ckycStatus = "error";
              payload.ckycDetail = JSON.stringify(res);
            }
            else {
              if (res.value.status == "SUCCESS") {
                payload.ckycStatus = "SUCCESS";
                // payload.ckycDetail = JSON.stringify(res.value.data);

                if (datares.imagE_DETAILS && datares.imagE_DETAILS.image) {
                  datares.imagE_DETAILS.image.forEach(image => {
                    image.imagE_DATA = ''; // Set imagE_DATA to an empty string
                  });
                }
                payload.ckycDetail = JSON.stringify(datares);
              }
              else {
                payload.ckycStatus = "error";
                payload.ckycDetail = JSON.stringify(res.value);
              }
            }
            this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
              async (res: any) => {
                this.showLoader = false;

                let response = JSON.parse(res.data);

                console.log("Pan Check Response ", response)


                if (response.typeOfInvestor === "Non-Individual") {

                  if (response.ckycCheck === 1) {
                    this.dismissModal();

                    this.commonService.encrypt(response.investorId).subscribe((res: any) => {
                      let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                      console.log('investorId', investorId);
                      console.log('After first')

                      this.commonService.encrypt(response.investmentId).subscribe((res: any) => {
                        console.log('After Second')
                        let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                        this.router.navigateByUrl(
                          'application/applicant-kyc-details/' + investorId + `/` + investmentId
                        );

                        // this.router.navigateByUrl(
                        //   'application/applicant-kyc-details/' + response.investorId + `/${response.investmentId}`
                        // );
                        return;

                      });
                    });



                  }
                  else {
                    this.dismissModal();
                    const modal = await this.modalController.create({
                      component: nonkycModelComponent,
                      backdropDismiss: false,
                      cssClass: 'my-custom-class',
                      componentProps: {
                        holder: response,
                        onPanCheck: true
                      }
                    });
                    await modal.present();
                    modal.onDidDismiss().then((event) => { });
                    return;
                  }

                }
                else {

                  // if (response.ckycCheck === 1) {
                  //   this.dismissModal();
                  //   this.router.navigateByUrl(
                  //     'application/applicant-kyc-details/' + response.investorId + `/${response.investmentId}`
                  //   );
                  //   return;
                  // }

                  if (response.ckycCheck === 0) {
                    this.dismissModal();
                    const modal = await this.modalController.create({
                      component: nonkycModelComponent,
                      backdropDismiss: false,
                      cssClass: 'my-custom-class',
                      componentProps: {
                        holder: response,
                        onPanCheck: true
                      }
                    });
                    await modal.present();
                    modal.onDidDismiss().then((event) => { });
                    return;
                  }
                  else {
                    this.commonService.updateHolder(res);
                    this.success.emit();
                  }

                }

                // if (res.success == false) {
                //   this.dismissModal();
                //   const modal = await this.modalController.create({
                //     component: OopsModalComponent,
                //     backdropDismiss: false,
                //     cssClass: 'my-custom-class',
                //   });
                //   await modal.present();
                //   modal.onDidDismiss().then((event) => { });
                //   return;
                // } else {
                //   this.commonService.updateHolder(res);
                //   this.success.emit();
                // }
              },
              async (err) => {
                this.showLoader = false;
                this.dismissModal();
                // const modal = await this.modalController.create({
                //   component: OopsModalComponent,
                //   backdropDismiss: false,
                //   cssClass: 'my-custom-class',
                // });
                // await modal.present();
                // modal.onDidDismiss().then((event) => { });
                // return;

                const toast = await this.toastController.create({
                  message: err.error.message,
                  duration: 2000,
                });
                toast.present();
              }
            );
            // }
            // else {
            //   console.log("CKCY Erro")
            //   console.log(JSON.stringify(res.value));
            // }
          });
      }
    }

    this.applicationService.getCKYCForNonIndi(reqBody).subscribe(
      async (res: any) => {
        let ckycAllData = null;

        let datares = res?.value?.data;
        if (!res || res.error == 1 || res.code === 500) {
          payload.ckycStatus = "error";
          payload.ckycDetail = JSON.stringify(res);
        }
        else {
          this.ckycFlag = true;
          if (res.value.status == "SUCCESS") {
            payload.ckycStatus = "SUCCESS";
            // payload.ckycDetail = JSON.stringify(res.value.data);

            if (datares.imagE_DETAILS && datares.imagE_DETAILS.image) {
              datares.imagE_DETAILS.image.forEach(image => {
                image.imagE_DATA = ''; // Set imagE_DATA to an empty string
              });
            }
            ckycAllData = JSON.stringify(datares);

            payload = {} as CreateApplication;
            payload.pan = this.form.pan.value;;
            payload.dateOfBirth = this.form.dateOfIncorporation.value;
            let newDate = new Date(payload.dateOfBirth);
            newDate.setDate(newDate.getDate())
            let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
            payload.dateOfBirth = formatedDate;

            this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
            console.log('this.childFund', this.childFund);
            payload.fundName = this.childFund[0].parentFunName;
            payload.fundID = this.childFund[0].parentFundId;
            payload.aifName = this.childFund[0].fundName;
            payload.childfundID = this.childFund[0].fundId;

            payload.rmName = this.form.rmName.value;
            payload.legalStatus = this.form.legalStatus.value;
            payload.typeOfEntity = this.form.typeOfEntity.value;
            payload.typeOfInvestor = this.form.typeOfInvestor.value;
            payload.POA = this.form.POA.value;
            payload.mobileNo = this.form.CKYCMobileNo.value
            payload.ckycStatus = "success";

            if (this.ckycSearchData !== null) {
              payload.ckycNumber = this.ckycSearchData
            } else {
              payload.ckycNumber = ""
            }
            payload.ckycDetail = ckycAllData;
            payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;

            if (this.transferIDs) {
              this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


              if (this.transferIDs.length > 0) {
                payload.transferId = this.form.transferId.value.id;
                payload.classs = this.transferIDs[0].classs;
                payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
                payload.initialContribution = this.transferIDs[0].initialContribution;
                payload.managementFees = this.transferIDs[0].managementFees;
                payload.setupFees = this.transferIDs[0].setupFees;
                payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

              }
            }

            payload.isTransfer = this.isTransferee;
            payload.transferId = 0;
            payload.KRA = "";

            this.showLoader = true;
            this.headerText = '';
            this.messageText = '';

            this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
              async (res: any) => {
                let data = JSON.parse(res.data)
                this.showLoader = false;
                this.commonService.encrypt(data.investorId).subscribe((res: any) => {
                  let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                  this.commonService.encrypt(data.investmentId).subscribe((res: any) => {
                    let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                    window.location.href = '/application/applicant-kyc-details/' + investorId + "/" + investmentId;

                  });

                });
              },
              async (error) => {
                this.showLoader = false;
                this.dismissModal();
                const toast = await this.toastController.create({
                  message: 'Something went wrong',
                  duration: 2000
                });
                toast.present();
              }
            );

          }
          else {
            payload.ckycStatus = "error";
            payload.ckycDetail = JSON.stringify(res.value);


            payload = {} as CreateApplication;
            payload.pan = this.form.pan.value;

            if (this.form.typeOfInvestor.value === "Non-Individual") {
              payload.dateOfIncorporation = this.form.dateOfIncorporation.value;
              let newDate = new Date(payload.dateOfIncorporation);
              newDate.setDate(newDate.getDate())
              let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
              payload.dateOfIncorporation = formatedDate;
            }
            else {
              payload.dateOfBirth = this.form.dob.value;
              let newDate = new Date(payload.dateOfBirth);
              newDate.setDate(newDate.getDate())
              let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
              payload.dateOfBirth = formatedDate;
            }

            this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
            console.log('this.childFund', this.childFund);
            payload.fundName = this.childFund[0].parentFunName;
            payload.fundID = this.childFund[0].parentFundId;
            payload.aifName = this.childFund[0].fundName;
            payload.childfundID = this.childFund[0].fundId;

            payload.rmName = this.form.rmName.value;
            payload.legalStatus = this.form.legalStatus.value;
            payload.typeOfEntity = this.form.typeOfEntity.value;
            payload.typeOfInvestor = this.form.typeOfInvestor.value;
            payload.POA = this.form.POA.value;
            payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;

            payload.ckycStatus = "error";
            payload.ckycDetail = JSON.stringify(null);

            if (this.transferIDs) {
              this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


              if (this.transferIDs.length > 0) {
                payload.transferId = this.form.transferId.value.id;
                payload.classs = this.transferIDs[0].classs;
                payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
                payload.initialContribution = this.transferIDs[0].initialContribution;
                payload.managementFees = this.transferIDs[0].managementFees;
                payload.setupFees = this.transferIDs[0].setupFees;
                payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

              }
            }

            payload.isTransfer = this.isTransferee;
            payload.transferId = 0;

            this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
              async (res: any) => {
                this.showLoader = false;

                let response = JSON.parse(res.data);

                this.dismissModal();
                const modal = await this.modalController.create({
                  component: nonkycModelComponent,
                  backdropDismiss: false,
                  cssClass: 'my-custom-class',
                  componentProps: {
                    holder: response,
                    onPanCheck: true
                  }
                });
                await modal.present();
                modal.onDidDismiss().then((event) => { });
                return;
              });


          }
        }

        //Check KRA Search API
        let formatedDate = formatDate(this.form.dateOfIncorporation.value, 'dd-MM-yyyy', 'en');
        const KRApayload = {
          PAN: payload.pan,
          DOB: formatedDate
        }


        this.applicationService.KRASearchAPI(KRApayload).subscribe({
          next: async (KRARes: any) => {
            console.log('KRARes', KRARes);
            if (KRARes.message.includes("PAN is not active or not found in KRA")) {
              console.log('PAN Not found');
              console.log('this.ckycSearchData', this.ckycSearchData);
              if (this.ckycSearchData == null || this.ckycSearchData == '') {
                let payload = {} as CreateApplication;
                payload.pan = this.form.pan.value;

                if (this.form.typeOfInvestor.value === "Non-Individual") {
                  payload.dateOfIncorporation = this.form.dateOfIncorporation.value;
                  let newDate = new Date(payload.dateOfIncorporation);
                  newDate.setDate(newDate.getDate())
                  let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                  payload.dateOfIncorporation = formatedDate;
                }
                else {
                  payload.dateOfBirth = this.form.dob.value;
                  let newDate = new Date(payload.dateOfBirth);
                  newDate.setDate(newDate.getDate())
                  let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                  payload.dateOfBirth = formatedDate;
                }

                this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
                console.log('this.childFund', this.childFund);
                payload.fundName = this.childFund[0].parentFunName;
                payload.fundID = this.childFund[0].parentFundId;
                payload.aifName = this.childFund[0].fundName;
                payload.childfundID = this.childFund[0].fundId;

                payload.rmName = this.form.rmName.value;
                payload.legalStatus = this.form.legalStatus.value;
                payload.typeOfEntity = this.form.typeOfEntity.value;
                payload.typeOfInvestor = this.form.typeOfInvestor.value;
                payload.POA = this.form.POA.value;
                payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;

                payload.ckycStatus = "error";
                payload.ckycDetail = JSON.stringify(null);

                if (this.transferIDs) {
                  this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


                  if (this.transferIDs.length > 0) {
                    payload.transferId = this.form.transferId.value.id;
                    payload.classs = this.transferIDs[0].classs;
                    payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
                    payload.initialContribution = this.transferIDs[0].initialContribution;
                    payload.managementFees = this.transferIDs[0].managementFees;
                    payload.setupFees = this.transferIDs[0].setupFees;
                    payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

                  }
                }

                payload.isTransfer = this.isTransferee;
                payload.transferId = 0;

                this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
                  async (res: any) => {
                    this.showLoader = false;

                    let response = JSON.parse(res.data);

                    this.dismissModal();
                    const modal = await this.modalController.create({
                      component: nonkycModelComponent,
                      //backdropDismiss: false,
                      cssClass: 'my-custom-class',
                      componentProps: {
                        holder: response,
                        onPanCheck: true
                      }
                    });
                    await modal.present();
                    modal.onDidDismiss().then((event) => { });
                    return;
                  });
              }
              else {
                this.showLoader = false;
                const modal = await this.modalController.create({
                  component: CkycOkayModel,
                  backdropDismiss: false,
                  cssClass: 'my-custom-class',
                  componentProps: {
                    onReturn: async () => {
                      this.dismissModal();
                      this.showSubmitButton = false;
                      this.panFixed = true;
                      this.dobFixed = true
                    }
                  }
                });
                await modal.present();
              }
            }
            else {
              this.applicationService.KRADownloadAPI(KRApayload).subscribe({
                next: async (KRADownloadRes: any) => {
                  console.log('KRADownloadRes', KRADownloadRes);
                  if (KRADownloadRes.message.includes("PAN is not active or not found in KRA")) {
                    console.log('PAN Not found');
                    this.KRAFlag = false;
                    this.showLoader = false;
                    const modal = await this.modalController.create({
                      component: CkycOkayModel,
                      backdropDismiss: false,

                      cssClass: 'my-custom-class',
                      componentProps: {
                        ckycFlag: this.ckycFlag,
                        KRAFlag: this.KRAFlag,
                        onReturn: async () => {
                          this.dismissModal();
                          this.applicantForm.get('CKYCMobileNo').setErrors(null)

                          this.applicantForm.markAllAsTouched();
                          if (this.applicantForm.invalid) return;
                          console.log('this.form.dateOfIncorporation.value', this.form.dateOfIncorporation.value);
                          let payload = {} as CreateApplication;
                          payload.pan = this.form.pan.value;;
                          payload.dateOfBirth = this.form.dateOfIncorporation.value;
                          let newDate = new Date(payload.dateOfBirth);
                          newDate.setDate(newDate.getDate())
                          let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                          payload.dateOfBirth = formatedDate;

                          this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
                          console.log('this.childFund', this.childFund);
                          payload.fundName = this.childFund[0].parentFunName;
                          payload.fundID = this.childFund[0].parentFundId;
                          payload.aifName = this.childFund[0].fundName;
                          payload.childfundID = this.childFund[0].fundId;

                          payload.rmName = this.form.rmName.value;
                          payload.legalStatus = this.form.legalStatus.value;
                          payload.typeOfEntity = this.form.typeOfEntity.value;
                          payload.typeOfInvestor = this.form.typeOfInvestor.value;
                          payload.POA = this.form.POA.value;
                          payload.mobileNo = this.form.CKYCMobileNo.value
                          payload.ckycStatus = "success";
                          if (this.ckycSearchData !== null) {
                            payload.ckycNumber = this.ckycSearchData
                          } else {
                            payload.ckycNumber = ""
                          }
                          payload.ckycDetail = ckycAllData;
                          payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;

                          if (this.transferIDs) {
                            this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


                            if (this.transferIDs.length > 0) {
                              payload.transferId = this.form.transferId.value.id;
                              payload.classs = this.transferIDs[0].classs;
                              payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
                              payload.initialContribution = this.transferIDs[0].initialContribution;
                              payload.managementFees = this.transferIDs[0].managementFees;
                              payload.setupFees = this.transferIDs[0].setupFees;
                              payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

                            }
                          }

                          payload.isTransfer = this.isTransferee;
                          payload.transferId = 0;
                          payload.KRA = "";

                          this.showLoader = true;
                          this.headerText = '';
                          this.messageText = '';
                          payload.ckycStatus = 'error';
                          this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
                            async (res: any) => {
                              let data = JSON.parse(res.data)
                              this.showLoader = false;
                              this.commonService.encrypt(data.investorId).subscribe((res: any) => {
                                let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                                this.commonService.encrypt(data.investmentId).subscribe((res: any) => {
                                  let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                                  window.location.href = '/application/applicant-kyc-details/' + investorId + "/" + investmentId;

                                });

                              });
                            },
                            async (error) => {
                              this.showLoader = false;
                              this.dismissModal();
                              const toast = await this.toastController.create({
                                message: 'Something went wrong',
                                duration: 2000
                              });
                              toast.present();
                            }
                          );
                        }
                      }
                    });
                    await modal.present();
                  }
                  else {
                    this.KRAFlag = true;
                    this.applicantForm.get('CKYCMobileNo').setErrors(null)

                    this.applicantForm.markAllAsTouched();
                    if (this.applicantForm.invalid) return;
                    console.log('this.form.dateOfIncorporation.value', this.form.dateOfIncorporation.value);
                    let payload = {} as CreateApplication;
                    payload.pan = this.form.pan.value;;
                    payload.dateOfBirth = this.form.dateOfIncorporation.value;
                    let newDate = new Date(payload.dateOfBirth);
                    newDate.setDate(newDate.getDate())
                    let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                    payload.dateOfBirth = formatedDate;

                    this.childFund = this.childFund.filter(x => x.fundId == this.form.aifName.value);
                    console.log('this.childFund', this.childFund);
                    payload.fundName = this.childFund[0].parentFunName;
                    payload.fundID = this.childFund[0].parentFundId;
                    payload.aifName = this.childFund[0].fundName;
                    payload.childfundID = this.childFund[0].fundId;

                    payload.rmName = this.form.rmName.value;
                    payload.legalStatus = this.form.legalStatus.value;
                    payload.typeOfEntity = this.form.typeOfEntity.value;
                    payload.typeOfInvestor = this.form.typeOfInvestor.value;
                    payload.POA = this.form.POA.value;
                    payload.mobileNo = this.form.CKYCMobileNo.value
                    payload.ckycStatus = "success";
                    if (this.ckycSearchData !== null) {
                      payload.ckycNumber = this.ckycSearchData
                    } else {
                      payload.ckycNumber = ""
                    }
                    payload.ckycDetail = "";
                    payload.applicationStatus = this.form.status.value === '' ? this.form.applicationStatus.value : this.form.status.value;

                    if (this.transferIDs) {
                      this.transferIDs = this.transferIDs.filter(x => x.id == this.form.transferId.value.id);


                      if (this.transferIDs.length > 0) {
                        payload.transferId = this.form.transferId.value.id;
                        payload.classs = this.transferIDs[0].classs;
                        payload.initialContributionPercentage = this.transferIDs[0].initialContributionPercentage;
                        payload.initialContribution = this.transferIDs[0].initialContribution;
                        payload.managementFees = this.transferIDs[0].managementFees;
                        payload.setupFees = this.transferIDs[0].setupFees;
                        payload.buyerCommitment = this.transferIDs[0].buyerCommitment;

                      }
                    }

                    payload.isTransfer = this.isTransferee;
                    payload.transferId = 0;
                    payload.KRA = JSON.stringify(KRADownloadRes);

                    this.showLoader = true;
                    this.headerText = '';
                    this.messageText = '';
                    this.applicationService.checkCKYCAndSaveApplication(payload).subscribe(
                      async (res: any) => {
                        let data = JSON.parse(res.data)
                        this.showLoader = false;
                        this.commonService.encrypt(data.investorId).subscribe((res: any) => {
                          let investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                          this.commonService.encrypt(data.investmentId).subscribe((res: any) => {
                            let investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
                            window.location.href = '/application/applicant-kyc-details/' + investorId + "/" + investmentId;

                          });

                        });
                      },
                      async (error) => {
                        this.showLoader = false;
                        this.dismissModal();
                        const toast = await this.toastController.create({
                          message: 'Something went wrong',
                          duration: 2000
                        });
                        toast.present();
                      }
                    );
                  }
                }
              });
            }
          }
        });
      });

  }
}